/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useContext } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import moment from "moment";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import * as Sentry from "@sentry/react";
import Typography from "../../../../../components/common/new/Typography/Typography";
import Button from "../../../../../components/common/Button/index";
import useUserConfig from "../../../../../hooks/useUserConfig";
import { AlertStatus, PERMISSIONS } from "../../../../../contants";
import Gohonzon from "../../../../../services/api/gohonzon";
import { ToastAlertContext } from "../../../../../config/providers/ToastAlert";

function StatusBlock({
  title,
  name,
  date,
  isCancelled,
  resendConsent,
  memberData,
  isHandover,
  batchId,
  showBatchId,
}) {
  const toast = useContext(ToastAlertContext);

  const sendConsent = async () => {
    try {
      const repsonse = await Gohonzon.sendGohonzonConsent({
        memberId: memberData?.memberId,
        applicationId: memberData?.id,
      });
      toast.show(repsonse?.data, AlertStatus.SUCCESS);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const hasPermission = useUserConfig();

  return (
    <Box
      style={
        isCancelled
          ? {
              minHeight: "40px",
              border: "1px solid #ff1744",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              backgroundColor: "rgb(255, 236, 240)",
            }
          : {
              minHeight: "40px",
              border: "1px solid #003E99",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }
      }
    >
      <Box style={{ margin: "18px" }}>
        <Typography
          style={{ marginLeft: "16px" }}
          fontSize="20px"
          fontWeight={600}
        >
          {isCancelled ? (
            <NotInterestedIcon
              color="error"
              style={{ marginBottom: "-4px", marginRight: "8px" }}
            />
          ) : name || date !== null ? (
            <CheckCircleIcon
              color="success"
              style={{ marginBottom: "-4px", marginRight: "8px" }}
            />
          ) : (
            <HourglassTopIcon
              color="warning"
              style={{ marginBottom: "-4px", marginRight: "8px" }}
            />
          )}
          {title}
        </Typography>
        {name || date !== null ? (
          <>
            <Typography style={{ marginLeft: "20px" }} fontSize="14px">
              {isHandover ? `To: ` : `By: `}
              <span style={{ fontWeight: 600 }}>
                {name !== null && name ? name : "NA"}
              </span>
            </Typography>
            <Typography style={{ marginLeft: "20px" }} fontSize="14px">
              {`On: `}
              <span style={{ fontWeight: 600 }}>
                {date !== null && date
                  ? moment(date).format("YYYY-MM-DD")
                  : "NA"}
              </span>
            </Typography>
            {showBatchId && memberData?.gohonzonType === "OKATAKI_GOHONZON" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Typography style={{ marginLeft: "20px" }} fontSize="14px">
                  {`Batch Id: `}
                  <span style={{ fontWeight: 600 }}>{batchId}</span>
                </Typography>
              </div>
            )}
          </>
        ) : (
          <Typography
            style={{ marginLeft: "40px", fontWeight: 600 }}
            fontSize="14px"
          >
            Pending
          </Typography>
        )}
        {resendConsent &&
          memberData.allowedToResendConsent &&
          hasPermission(PERMISSIONS.RESEND_GOHONZON_CONSENT) && (
            <Button
              label="Resend Consent"
              style={{ marginLeft: "40px", width: "160px" }}
              onClick={sendConsent}
            />
          )}
      </Box>
    </Box>
  );
}

export default StatusBlock;
